export default (first, second) => {
    const firstRecordOrderVal = parseInt(first.order, 10);
    const secondRecordOrderVal = parseInt(second.order, 10);
  
    if (Number.isNaN(firstRecordOrderVal) && Number.isNaN(secondRecordOrderVal)) {
      return 0;
    }
    if (Number.isNaN(firstRecordOrderVal) && !Number.isNaN(secondRecordOrderVal)) {
      return 1;
    }
    if (!Number.isNaN(firstRecordOrderVal) && Number.isNaN(secondRecordOrderVal)) {
      return -1;
    }
    if (firstRecordOrderVal < secondRecordOrderVal) {
      return -1;
    }
    if (firstRecordOrderVal > secondRecordOrderVal) {
      return 1;
    }
    // if firstRecordOrderVal === secondRecordOrderVal
    return 0;
  
  };
  